import { memo } from 'react';
import { SimpleSkeleton } from '@/sub-luca-plugin/compatible-components';
import './index.scss';

const MyCollectSkeleton = () => {
    return (
        <div className="my-collect-skeleton">
            {new Array(10).fill(null).map((_, index) => (
                <SimpleSkeleton key={index} className="my-collect-skeleton__item" />
            ))}
        </div>
    );
};

export default memo(MyCollectSkeleton);
